import $ from 'jquery';

$(document).ready(() => {
  const $searchBtn = $('.js-search-btn');
  const $searchCloseBtn = $('.js-search-close');
  const $searchModel = $('.js-search-model');
  const $searchBox = $('.js-search-box');
  const $searchSubmitButton = $('.js-search-submit');
  const $searchUrl = $('input#hdnSearchResultsUrl');
  const $searchKeyword = $('#searchInput');
  const $body = $('body');
  const ACTIVE = 'is-active';
  const NOSCROLL = 'no-scroll-search';

  $searchBtn.on('click', () => {
    $searchModel.addClass(ACTIVE);
    $body.addClass(NOSCROLL);
    $searchBox.focus();
  });

  $searchCloseBtn.on('click', () => {
    $searchModel.removeClass(ACTIVE);
    $body.removeClass(NOSCROLL);
    $searchBox.blur();
  });

  $searchSubmitButton.on('click', () => {
    if ($searchUrl.val() && $searchKeyword.val().length > 0) {
      window.location.replace(`${$searchUrl.val()}?keyword=${$searchKeyword.val()}`);
    }
  });

  $searchBox.keypress((e) => {
    if (e.which === 13) {
      if ($searchUrl.val() && $searchKeyword.val().length > 0) {
        window.location.replace(`${$searchUrl.val()}?keyword=${$searchKeyword.val()}`);
      }
    }
  });
});
